import { useState, useEffect, useRef } from "react";

function useInView(threshold = 0.1) {
	const ref = useRef();
	const [visible, setVisible] = useState(false);

	useEffect(() => {
		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						setVisible(true);
					} else {
						setVisible(false);
					}
				});
			},
			{ threshold },
		);
		const current = ref.current;
		if (current) observer.observe(current);
		return () => {
			if (current) observer.unobserve(current);
		};
	}, [threshold]);

	return [ref, visible];
}

export default useInView;
